import lodash from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import LinearProgress from '@material-ui/core/LinearProgress';
import moment from 'moment';
import { vrm_titles } from '../statics';
import Table from '../../../../../components/table/Table';
import { get } from '../../../../../shared/helpers';
import { getDivisionAbbr } from '../../../utils/getDivisionAbbr';

const SHORT_VRMS_LIST_COUNT = 3;
const HIDE_DATA_FOR_SOURCES = [
    // Leadomatic
    '5be93e5f683059f77dbcef4c',
    undefined,
];

class VRMDuplicates extends Component {
    state = {
        part_vrms: SHORT_VRMS_LIST_COUNT,
    };

    showAllDuplicates = () => this.setState({ part_vrms: this.props.vrmDuplicatesData.vrmsList.length });

    hideAllDuplicates = () => this.setState({ part_vrms: SHORT_VRMS_LIST_COUNT });

    buildMainContent() {
        const { vrmDuplicatesData } = this.props;
        const isAdminOrSuper = this.props.userGroups.some(group => group._id === '5d7f6909bdee754d2fc96667' || group._id === '5b6a9ee2ba52006858939023' || group._id === '5b6a9ee2ba52006858939024');
        const contentExists = lodash.isArray(vrmDuplicatesData.vrmsList) && vrmDuplicatesData.vrmsList.length;

        const emptyContent = <span style={{ fontStyle: 'italic', width: '100%' }}>There are no VRM duplicates for this bike</span>;
        const content = contentExists && (
            <Table>
                <thead>
                    <tr>{vrm_titles.map((title, index) => <th key={index} className="tableHeader">{title}</th>)}</tr>
                </thead>
                <tbody>
                    {
                        vrmDuplicatesData.vrmsList.slice(0, this.state.part_vrms).map((item) => {
                            const last_valuation = item.valuations && item.valuations.length && (item.valuations[item.valuations.length - 1] || {});
                            return (
                                <tr key={item._id}>
                                    <td>
                                        <a href={`/Leads/Lead_profile/${item._id}`}>
                                            {getDivisionAbbr(get(item, 'ref_lead_source.abbr'))}
                                        </a>
                                    </td>
                                    <td>{new moment(item.created_date).format('DD-MM-YYYY')}</td>
                                    <td>
                                        £
                                        {last_valuation.valuation || '-'}
                                    </td>
                                    {isAdminOrSuper && (
                                        <td>
                                            £
                                            {last_valuation.retail_price || '-'}
                                        </td>
                                    )}
                                    {!isAdminOrSuper && <td>-</td>}
                                    <td>
                                        {last_valuation.valuation_by ? (
                                            <>
                                                {last_valuation.valuation_by.person.first_name.substring(0, 1)}
                                                {last_valuation.valuation_by.person.last_name.substring(0, 1)}
                                            </>
                                        ) : '-'}
                                    </td>
                                    <td>{item.ref_lead_status.name || '-'}</td>
                                </tr>
                            );
                        })
                    }
                </tbody>
            </Table>
        );

        return contentExists ? content : emptyContent;
    }

    render() {
        const { vrmDuplicatesData } = this.props;
        const leadSource = lodash.get(this, 'props.ref_lead_source._id');
        // AdminOrSuper: 'Sales' 'Administrator', 'Super User', 'Call Center Agent'
        const isAdminOrSuper = this.props.userGroups.some(group =>
            group._id === '5d7f6909bdee754d2fc96667' ||
            group._id === '5b6a9ee2ba52006858939023' ||
            group._id === '5b6a9ee2ba52006858939024' ||
            group._id === '5bb5cf4387ccbe393434b647');

        return (
            (!HIDE_DATA_FOR_SOURCES.includes(leadSource) && isAdminOrSuper) && (
                <div className="profile__information cap">
                    <div className="profile__data valuation">
                        <h3>
                            VRM Duplicates
                            {
                                vrmDuplicatesData.vrmsList.length > SHORT_VRMS_LIST_COUNT && this.state.part_vrms === SHORT_VRMS_LIST_COUNT
                                    ? <span className="select_manually" onClick={this.showAllDuplicates}>Show all duplicates</span>
                                    : this.state.part_vrms > SHORT_VRMS_LIST_COUNT
                                        ? <span className="select_manually" onClick={this.hideAllDuplicates}>Hide all duplicates</span>
                                        : null
                            }
                        </h3>
                        <div className="tableWrapper">
                            <div className="profile__contact">
                                {
                                    vrmDuplicatesData.isLoading
                                        ? <LinearProgress />
                                        : this.buildMainContent()
                                }
                            </div>
                        </div>
                    </div>
                </div>
            )
        );
    }
}

const mapStateToProps = (state) => {
    const { vrmDuplicates } = state.Leads.Lead_profile.Lead_general;
    const { ref_lead_source } = state.Leads.Lead_profile.Lead_marketing;
    const userGroups = lodash.get(state, 'App.App_content.user.groups');

    return {
        vrmDuplicatesData: vrmDuplicates,
        ref_lead_source,
        userGroups,
    };
};

export default connect(mapStateToProps, null)(VRMDuplicates);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_table/VRMDuplicates.js